/* Approved 11 October 2026: selling amounts round down to whole pounds.
 * Supplier reference data and existing Ethnicraft prices remain unchanged. */
window.FultonsSellingPrice = window.FultonsSellingPrice || ((value, preserveEthnicraft = false) => {
  if (preserveEthnicraft || typeof value !== 'number' || !Number.isFinite(value) || value <= 0) return value;
  return Math.floor(value + 1e-9);
});
/* Bontempi additions for the unpublished Fultons catalogue. */
(() => {
  'use strict';
  if (String(window.FultonsDraftPreview?.themeId) !== '199663649151') return;
  const additions = [
  {
    "id": "gid://shopify/Product/15889590714751",
    "title": "Amelie Dining Chair",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-dining-chairs"
    ],
    "descriptionHtml": "<p>A generously padded dining chair with a softly gathered, enveloping back. Amelie is available with two metal leg designs or a solid wood frame, with a choice of fabric and leather coverings.</p><h3>Dimensions</h3><p>Width 58 × depth 62 × overall height 82 cm. Models 34.90, 34.91 and 34.92. Seat height varies with the frame.</p><h3>Materials and options</h3><p>Upholstery and frame finishes vary by version. Ask the showroom to help coordinate your chosen covering and leg finish.</p><h3>Starting configuration</h3><p>34.92 with standard lacquered metal legs and Premium Eco Leather or Bouquet fabric. Price per chair.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704379781503"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-amelie-cutout.webp?v=1789388923",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-amelie-cutout.webp?v=1789388923",
        "altText": "Amelie Dining Chair — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569508561279"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-amelie-gallery.jpg?v=1789388935",
        "altText": "Amelie Dining Chair — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569509314943"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-amelie-cutout.webp?v=1789388923"
    ],
    "rrp": 667,
    "sale": 565,
    "menuSale": 565,
    "baseConfiguration": "34.92 with standard lacquered metal legs and Premium Eco Leather or Bouquet fabric. Price per chair."
  },
  {
    "id": "gid://shopify/Product/15889590780287",
    "title": "Nova Dining Chair",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-dining-chairs",
      "price-on-request"
    ],
    "descriptionHtml": "<p>Nova combines a curved, upholstered back with soft folds and a slim supporting frame. Choose a dining chair with or without arms to suit your table and room.</p><h3>Dimensions</h3><p>Without arms, models 35.12–35.14: width 51.5 × depth 58 × height 80.5 cm. With arms, models 35.15–35.17: width 59 × depth 58 × height 80.5 cm. Seat height 49 cm.</p><h3>Materials and options</h3><p>Contact our showroom for the current upholstery and frame combinations and a quotation.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704379781503"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nova-cutout.png?v=1789388940",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nova-cutout.png?v=1789388940",
        "altText": "Nova Dining Chair — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569510101375"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nova-gallery.jpg?v=1789388944",
        "altText": "Nova Dining Chair — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569510330751"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nova-cutout.png?v=1789388940"
    ],
    "rrp": null,
    "sale": 0,
    "menuSale": 0,
    "baseConfiguration": null,
    "verifiedOriginalImageUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nova-gallery.jpg?v=1789388944"
    ]
  },
  {
    "id": "gid://shopify/Product/15889590878591",
    "title": "Barone Dining Table",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-dining-tables"
    ],
    "descriptionHtml": "<p>Barone has a sculptural metal base formed by sweeping, intersecting supports. The collection includes fixed round and elliptical tables, an extending round version and a Ring version with a rotating centre.</p><h3>Dimensions</h3><p>Fixed round versions include diameters 110, 120, 130 and 150 cm. The elliptical version measures 180 × 115 cm. The extending round version opens from 125 to 175 cm. Fixed versions are 75 cm high; the extending version is 76 cm and the Ring version is 77 cm.</p><h3>Materials and options</h3><p>Glass, wood and SuperMarble tops are available on selected versions. Size, top and base finish determine the final price.</p><h3>Starting configuration</h3><p>01.79, diameter 110 cm, with a standard lacquered metal base and selected transparent or glossy lacquered glass top.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704379781503"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-barone-cutout.webp?v=1789388948",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-barone-cutout.webp?v=1789388948",
        "altText": "Barone Dining Table — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569510429055"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-barone-gallery.jpg?v=1789388953",
        "altText": "Barone Dining Table — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569510756735"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-barone-cutout.webp?v=1789388948"
    ],
    "rrp": 1702,
    "sale": 1445,
    "menuSale": 1445,
    "baseConfiguration": "01.79, diameter 110 cm, with a standard lacquered metal base and selected transparent or glossy lacquered glass top."
  },
  {
    "id": "gid://shopify/Product/15889590944127",
    "title": "Kaleido Dining Table",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-dining-tables"
    ],
    "descriptionHtml": "<p>Kaleido pairs a geometric metal base with a choice of table shapes and surfaces. Its angled supports create a sculptural centrepiece for a dining room.</p><h3>Dimensions</h3><p>The range includes fixed and extending rectangular and barrel tables, plus round and Ring versions. The starting rectangular version measures 160 × 90 × 75 cm. Ask the showroom for the dimensions of your preferred shape and extension.</p><h3>Materials and options</h3><p>Wood, glass, SuperCeramic and SuperMarble tops are available on selected sizes. The pictured table may be a different size or finish from the starting configuration.</p><h3>Starting configuration</h3><p>54.30, 160 × 90 cm, with a standard lacquered metal base and glossy lacquered glass top.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704379781503"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-kaleido-cutout.webp?v=1789388958",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-kaleido-cutout.webp?v=1789388958",
        "altText": "Kaleido Dining Table — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569510855039"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-kaleido-gallery.jpg?v=1789388964",
        "altText": "Kaleido Dining Table — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569511412095"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-kaleido-cutout.webp?v=1789388958"
    ],
    "rrp": 2555,
    "sale": 2171.99,
    "menuSale": 2170,
    "baseConfiguration": "54.30, 160 × 90 cm, with a standard lacquered metal base and glossy lacquered glass top."
  },
  {
    "id": "gid://shopify/Product/15889591107967",
    "title": "Helena Bookcase",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-bookcases-storage",
      "type-bookcases"
    ],
    "descriptionHtml": "<p>Helena is an open bookcase with broad vertical supports and a rounded outer profile. Choose an all-metal composition or add a coordinated set of decorative shelf surfaces.</p><h3>Dimensions</h3><p>18.75: width 130 × depth 40 × height 184 cm. 18.76: width 180 × depth 40 × height 184 cm. 18.77: width 240 × depth 40 × height 184 cm.</p><h3>Materials and options</h3><p>Selected versions add wood veneer, SuperCeramic or SuperMarble shelf surfaces. Wall-fixing equipment is specified; discuss the appropriate fixing arrangement with our showroom.</p><h3>Starting configuration</h3><p>18.75, width 130 cm, with an integrated lacquered metal frame and shelves.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-helena-cutout.webp?v=1789388968",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-helena-cutout.webp?v=1789388968",
        "altText": "Helena Bookcase — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569511772543"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-helena-gallery.jpg?v=1789388987",
        "altText": "Helena Bookcase — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569513509247"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-helena-cutout.webp?v=1789388968"
    ],
    "rrp": 3879,
    "sale": 3295,
    "menuSale": 3295,
    "baseConfiguration": "18.75, width 130 cm, with an integrated lacquered metal frame and shelves."
  },
  {
    "id": "gid://shopify/Product/15889591140735",
    "title": "Kunta Sideboard",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-sideboards-storage"
    ],
    "descriptionHtml": "<p>Kunta brings an angular, sculpted rhythm to a dining or living room. Its shaped door fronts conceal useful storage with clear glass internal shelves.</p><h3>Dimensions</h3><p>Two-door versions are 144 cm wide; three-door versions are 216 cm wide. Overall height is 69.5 cm on the low base or 79.5 cm on raised legs. Depth 50 cm, as listed in the 2026 UK price list.</p><h3>Materials and options</h3><p>Choose selected matt or brushed lacquer finishes. Additional tops and internal drawers are optional. The back is intended to sit against a wall; wall fixing is recommended.</p><h3>Starting configuration</h3><p>15.90, two doors, width 144 cm, in a standard matt lacquered finish.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704379781503",
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-bontempi-kunta-clear-top-20260914.png?v=1789389937",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-bontempi-kunta-clear-top-20260914.png?v=1789389937",
        "altText": "Bontempi Kunta Sideboard with clear top",
        "mediaId": "gid://shopify/MediaImage/72569622823295"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-kunta-gallery.webp?v=1789388994",
        "altText": "Kunta Sideboard — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569514656127"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-bontempi-kunta-clear-top-20260914.png?v=1789389937"
    ],
    "rrp": 2813,
    "sale": 2486.69,
    "menuSale": 2485,
    "baseConfiguration": "15.90, two doors, width 144 cm, in a standard matt lacquered finish."
  },
  {
    "id": "gid://shopify/Product/15889591206271",
    "title": "Audrey Display Cabinet",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-sideboards-storage"
    ],
    "descriptionHtml": "<p>Audrey is a tall glass display cabinet with slender metal framing. Two doors open onto three internal shelves, while integrated lighting highlights the pieces displayed inside.</p><h3>Dimensions</h3><p>Width 100 × depth 40 × height 163 cm. Model 15.53.</p><h3>Materials and options</h3><p>Transparent bronze glass C159 with dark brass M028 frame, feet and handles. Internal LED lighting is included.</p><h3>Starting configuration</h3><p>15.53 in transparent bronze glass with a dark brass frame and internal LED lighting.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704379781503",
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-audrey-cutout.webp?v=1789388998",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-audrey-cutout.webp?v=1789388998",
        "altText": "Audrey Display Cabinet — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569514688895"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-audrey-gallery.jpg?v=1789389004",
        "altText": "Audrey Display Cabinet — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569514787199"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-audrey-cutout.webp?v=1789388998"
    ],
    "rrp": 8291,
    "sale": 7329.24,
    "menuSale": 7330,
    "baseConfiguration": "15.53 in transparent bronze glass with a dark brass frame and internal LED lighting."
  },
  {
    "id": "gid://shopify/Product/15889591239039",
    "title": "Elvis Cocktail Cabinet",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-sideboards-storage"
    ],
    "descriptionHtml": "<p>Elvis is a raised cocktail cabinet with bronze-tinted glass and a slender metal frame. It offers a decorative place for glassware and drinks in a dining or living space.</p><h3>Dimensions</h3><p>Width 120 × depth 43 × height 116 cm. Cabinet model 15.55.</p><h3>Materials and options</h3><p>Transparent bronze glass C159 and dark brass M028 metal. The additional internal shelf, model 15.56, is an optional accessory.</p><h3>Starting configuration</h3><p>15.55 cabinet in transparent bronze glass with a dark brass metal frame. Optional shelf is additional.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704379781503",
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-bontempi-elvis-clear-top-20260914.png?v=1789389944",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-bontempi-elvis-clear-top-20260914.png?v=1789389944",
        "altText": "Bontempi Elvis Cocktail Cabinet with clear top",
        "mediaId": "gid://shopify/MediaImage/72569624068479"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-elvis-gallery.jpg?v=1789389014",
        "altText": "Elvis Cocktail Cabinet — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569514951039"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/fultons-bontempi-elvis-clear-top-20260914.png?v=1789389944"
    ],
    "rrp": 3064,
    "sale": 2605,
    "menuSale": 2605,
    "baseConfiguration": "15.55 cabinet in transparent bronze glass with a dark brass metal frame. Optional shelf is additional."
  },
  {
    "id": "gid://shopify/Product/15889591304575",
    "title": "Bolt Coffee & Side Tables",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-coffee-side-tables",
      "price-on-request"
    ],
    "descriptionHtml": "<p>Bolt combines a rounded top with a sculptural metal support that becomes part of the tabletop design. Different sizes and heights can be used individually or arranged together.</p><h3>Dimensions</h3><p>08.55: diameter 52 × height 46 cm. 08.56: diameter 90 × height 38 cm. 08.57: width 120 × depth 60 × height 30 cm.</p><h3>Materials and options</h3><p>Contact our showroom for the current top and metal finish combinations. Tables are supplied individually.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-bolt-cutout.png?v=1789389020",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-bolt-cutout.png?v=1789389020",
        "altText": "Bolt Coffee & Side Tables — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569515803007"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-bolt-gallery.webp?v=1789389042",
        "altText": "Bolt Coffee & Side Tables — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569516491135"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-bolt-cutout.png?v=1789389020"
    ],
    "rrp": null,
    "sale": 0,
    "menuSale": 0,
    "baseConfiguration": null,
    "verifiedOriginalImageUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-bolt-gallery.webp?v=1789389042"
    ]
  },
  {
    "id": "gid://shopify/Product/15889591337343",
    "title": "Core Coffee & Side Tables",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-coffee-side-tables",
      "price-on-request"
    ],
    "descriptionHtml": "<p>Core places circular tops on sculptural curved supports. The collection combines compact side tables with broad, low coffee tables for layered living-room arrangements.</p><h3>Dimensions</h3><p>08.58: diameter 45 × height 54 cm. 08.59: diameter 50 × height 42 cm. 08.60: diameter 100 × height 25 cm. 08.61: diameter 125 × height 18 cm.</p><h3>Materials and options</h3><p>Contact our showroom for current top and base finishes. Each table is supplied separately.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-core-cutout.webp?v=1789389046",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-core-cutout.webp?v=1789389046",
        "altText": "Core Coffee & Side Tables — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569517343103"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-core-gallery.webp?v=1789389050",
        "altText": "Core Coffee & Side Tables — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569517900159"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-core-cutout.webp?v=1789389046"
    ],
    "rrp": null,
    "sale": 0,
    "menuSale": 0,
    "baseConfiguration": null,
    "verifiedOriginalImageUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-core-gallery.webp?v=1789389050"
    ]
  },
  {
    "id": "gid://shopify/Product/15889591370111",
    "title": "Flow Coffee Tables",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-coffee-side-tables",
      "price-on-request"
    ],
    "descriptionHtml": "<p>Flow pairs a softly shaped top with a folded, sculptural base. Its organic outline works as a single coffee table or as part of a layered arrangement.</p><h3>Dimensions</h3><p>08.62: width 90 × depth 70 × height 35 cm. 08.63: width 110 × depth 70 × height 30 cm. 08.64: width 130 × depth 80 × height 30 cm.</p><h3>Materials and options</h3><p>Ask our showroom about the current top and base finishes. Tables are supplied individually.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-flow-cutout.png?v=1789389054",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-flow-cutout.png?v=1789389054",
        "altText": "Flow Coffee Tables — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569518195071"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-flow-gallery.jpg?v=1789389059",
        "altText": "Flow Coffee Tables — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569518358911"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-flow-cutout.png?v=1789389054"
    ],
    "rrp": null,
    "sale": 0,
    "menuSale": 0,
    "baseConfiguration": null,
    "verifiedOriginalImageUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-flow-gallery.jpg?v=1789389059"
    ]
  },
  {
    "id": "gid://shopify/Product/15889591468415",
    "title": "Nexus Coffee & Side Tables",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-coffee-side-tables",
      "price-on-request"
    ],
    "descriptionHtml": "<p>Nexus combines softly irregular tops with cylindrical supports. The collection offers different heights and proportions for use beside a sofa or together in a coffee-table arrangement.</p><h3>Dimensions</h3><p>08.65: width 48 × depth 40 × height 50 cm. 08.66: width 86 × depth 62 × height 36 cm. 08.67: width 124 × depth 74 × height 28 cm. 08.68: width 124 × depth 74 × height 36 cm.</p><h3>Materials and options</h3><p>Contact our showroom for the current finish combinations. Each table is supplied separately.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nexus-cutout.webp?v=1789389063",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nexus-cutout.webp?v=1789389063",
        "altText": "Nexus Coffee & Side Tables — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569518424447"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nexus-gallery.jpg?v=1789389068",
        "altText": "Nexus Coffee & Side Tables — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569518522751"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nexus-cutout.webp?v=1789389063"
    ],
    "rrp": null,
    "sale": 0,
    "menuSale": 0,
    "baseConfiguration": null,
    "verifiedOriginalImageUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-nexus-gallery.jpg?v=1789389068"
    ]
  },
  {
    "id": "gid://shopify/Product/15889591501183",
    "title": "Circus Coffee & Side Tables",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-coffee-side-tables"
    ],
    "descriptionHtml": "<p>Circus has a circular top and an open metal rod base. Its three sizes can stand alone or be combined at different heights.</p><h3>Dimensions</h3><p>08.31: diameter 45 × height 42 cm. 08.32: diameter 60 × height 36 cm. 08.33: diameter 100 × height 30 cm.</p><h3>Materials and options</h3><p>Choose selected matt or glossy SuperMarble tops with a lacquered metal base. Special metal finishes are available at an additional cost. Tables are supplied individually.</p><h3>Starting configuration</h3><p>08.31, diameter 45 cm, with a standard lacquered metal base and matt SuperMarble top. Price for one table.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-circus-cutout.webp?v=1789389082",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-circus-cutout.webp?v=1789389082",
        "altText": "Circus Coffee & Side Tables — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569519178111"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-circus-gallery.jpg?v=1789389087",
        "altText": "Circus Coffee & Side Tables — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569521308031"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-circus-cutout.webp?v=1789389082"
    ],
    "rrp": 684,
    "sale": 580,
    "menuSale": 580,
    "baseConfiguration": "08.31, diameter 45 cm, with a standard lacquered metal base and matt SuperMarble top. Price for one table."
  },
  {
    "id": "gid://shopify/Product/15889591566719",
    "title": "Zac Desk",
    "vendor": "Bontempi",
    "tags": [
      "brand-bontempi",
      "fultons-feasibility-test",
      "fultons-import-20260914",
      "not-for-sale",
      "type-desks"
    ],
    "descriptionHtml": "<p>Zac is a writing desk with two drawers and raised metal trays for organising a workspace. A veneered top and slender metal frame give it a light, architectural appearance.</p><h3>Dimensions</h3><p>Width 134 × depth 67 cm; desktop height 75 cm and overall height including trays 88 cm, as listed in the 2026 UK price list. Model 06.32.</p><h3>Materials and options</h3><p>Natural oak L009 or Spessart oak L002 veneer with selected metal finishes. The hide-leather desk pad, model 06.32SM, is optional.</p><h3>Starting configuration</h3><p>06.32 in natural oak or Spessart oak veneer with a standard lacquered metal frame, two drawers and two metal trays.</p><p>Contact our Lurgan showroom to discuss your preferred size and finish. Other furniture, lighting and styling accessories shown are supplied separately.</p>",
    "collectionIds": [
      "704334037375"
    ],
    "featuredImageUrl": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-zac-cutout.png?v=1789389092",
    "images": [
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-zac-cutout.png?v=1789389092",
        "altText": "Zac Desk — manufacturer cutout",
        "mediaId": "gid://shopify/MediaImage/72569521668479"
      },
      {
        "url": "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-zac-gallery.webp?v=1789389096",
        "altText": "Zac Desk — manufacturer room setting",
        "mediaId": "gid://shopify/MediaImage/72569521930623"
      }
    ],
    "verifiedOriginalCutoutUrls": [
      "https://cdn.shopify.com/s/files/1/1031/2473/0239/files/bontempi-zac-cutout.png?v=1789389092"
    ],
    "rrp": 1736,
    "sale": 1475,
    "menuSale": 1475,
    "baseConfiguration": "06.32 in natural oak or Spessart oak veneer with a standard lacquered metal frame, two drawers and two metal trays."
  }
];
  const idOf = p => String(p.id).split('/').pop();
  const existing = window.FultonsDraftProducts || [];
  const ids = new Set(existing.map(idOf));
  additions.forEach(p => { if (!ids.has(idOf(p))) { existing.push(p); ids.add(idOf(p)); } });
  window.FultonsDraftProducts = existing;
  const money = (value, reference = false) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0 }).format(reference ? Math.floor(Number(value)+1e-9) : Math.round(value / 5) * 5);
  function showStartingPrice() {
    const id = new URL(location.href).searchParams.get('draft_product');
    const product = additions.find(p => idOf(p) === id);
    if (!product?.rrp) return;
    const root = document.querySelector('#MainContent .catalogue-proof:not([hidden])');
    const description = root?.querySelector('.catalogue-proof__description');
    if (!description || description.querySelector('[data-bontempi-starting-price]')) return;
    const heading = [...description.querySelectorAll('h3')].find(h => h.textContent.trim() === 'Starting configuration');
    const anchor = heading?.nextElementSibling;
    if (!anchor) return;
    const summary = document.createElement('div');
    summary.className = 'fultons-selected-price';
    summary.dataset.bontempiStartingPrice = id;
    [['s', money(product.rrp,true), 'fultons-selected-price__rrp'], ['strong', 'Fultons price from ' + money(product.sale), 'fultons-selected-price__sale']].forEach(([tag, text, cls]) => {
      const el = document.createElement(tag); el.textContent = text; el.className = cls; summary.append(el);
    });
    anchor.after(summary);
  }
  function initialise() {
    window.FultonsProductOptions = window.FultonsProductOptions || {};
    const rrps = window.FultonsVerifiedRrps;
    additions.filter(p => p.rrp > 0).forEach(p => {
      const id = idOf(p);
      window.FultonsProductOptions[id] = { title: p.title, vendor: p.vendor, fromPrice: p.sale, options: [] };
      if (rrps) { rrps.menu = rrps.menu || {}; rrps.menu[id] = { [String(p.menuSale)]: p.rrp }; }
    });
    document.addEventListener('fultons:catalogue-updated', showStartingPrice);
    document.dispatchEvent(new CustomEvent('fultons:catalogue-updated'));
    showStartingPrice();
  }
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', initialise, { once: true }); else initialise();
})();

